import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import { IcoHome, IcoBed, IcoCar, IcoWave } from "./icons";
import SmartImage from "./SmartImage";
import { coverSizes } from "../../lib/predio";

const CHIP_ICONS = [IcoHome, IcoBed, IcoCar];

// .card tem altura fixa de 520px; a coluna fica em ~327px na grade de 4.
const CARD_BOX = { width: 340, height: 520 };

export default function Card({ predio }) {
  return (
    <Link
      className="card"
      to={`/empreendimento/${predio.slug}`}
      data-cidade={predio.cidadeFilter}
      data-status={predio.statusFilter}
      data-dorm={predio.dormValues.join(",")}
      data-finalidade={predio.finalidadeFilter}
    >
      <div className="card-media">
        <SmartImage
          img={predio.cardImg}
          alt={predio.name}
          sizes={coverSizes(predio.cardImg, CARD_BOX)}
        />
        <span className={`badge ${predio.statusClass}`}>{predio.badgeText}</span>
        <span className="card-hint">↗</span>
        <div className="card-overlay">
          <h3>{predio.name}</h3>
          <div className="card-city">{predio.cidadeDisplay}</div>
          <div className="card-chips">
            {predio.chips.map((chip, i) => {
              const Icon = CHIP_ICONS[i];
              return (
                <span key={chip} title={chip}>
                  {Icon && <Icon />}
                  {/* O texto precisa de um elemento próprio: o text-overflow
                      não age sobre um item de flex anônimo. */}
                  <span className="chip-text">{chip}</span>
                </span>
              );
            })}
          </div>
          {predio.beach && (
            <div className="card-beach">
              <IcoWave /> A {predio.beach} da praia
            </div>
          )}
        </div>
      </div>
    </Link>
  );
}

Card.propTypes = {
  predio: PropTypes.object.isRequired,
};
